// Example React.js code to handle the token from the URL
import React, { useEffect, useState } from 'react';
import {  useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API } from './backend';


const Impersonate = ({ setRtl }) => {
    const [companyname, SetCompanyName] = useState("")
    const [username, SetUserName] = useState("")
    // const history = useLocation();
    let navigate = useNavigate();
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const token = params.get('token');
        const id = params.get('id');
        const cid = params.get('cid')
        const company = params.get('companyname')
        SetCompanyName(company)

        if (token) {
            localStorage.setItem('access', token);
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            axios.get(API + `impesonate_details/?id=${id}&cid=${cid}&token=${token}`)
                .then(response => {
                    if (response.data) {

                        localStorage.setItem("user", JSON.stringify(response.data));
                        localStorage.setItem("username", JSON.stringify(response.data.username));
                        localStorage.setItem("locale", response.data.locale)
                        localStorage.setItem("currency", response.data.currency)
                        localStorage.setItem("companyid", response.data.companyid)
                        localStorage.setItem("parent", response.data.parent)
                        localStorage.setItem("permissions", response.data.permissions)
                        localStorage.setItem("customer", response.data.customer)
                        localStorage.setItem("userid", response.data.user_id)
                        localStorage.setItem("last_login", response.data.lastlogin)
                        localStorage.setItem("companyName", response.data.companyName)
                        localStorage.setItem("inpersonate_login",1)

                        SetUserName(response.data.username)
                        setRtl(false)

                        navigate('/'); // Redirect to the desired route after login

                    } else {
                        console.error('Token verification failed.');
                        // Redirect to login or show an error message
                        navigate('/login');
                    }
                })
                .catch(error => {
                    console.error('Error verifying token:', error);
                    // Handle error appropriately
                    navigate('/login'); // Redirect to login if there's an issue
                });
            // window.location.replace('/'); // Redirect to the desired route after login
        }
    }, [navigate]);

    return <div className='mt-20 text-center'>
        <h1>
            Logging you in...

        </h1>
        <br />
        <h3>
            <span className='tc'> Company Name </span> : {companyname}
        </h3>
        <br />
        <h4 className='mt-2'>
            <span className='tc'> User Name </span> : {username}
        </h4>

    </div>;
};

export default Impersonate;
